var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"cms-main-content"},[_vm._t("default"),_c('router-view')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }